import Modal from "../../../Framework/Components/Modals/Modal";
import Button from "../../../Framework/Components/Buttons/Button";
import {ModalType} from "../../../Framework/Components/Modals/ModalTypes";
import {
    SendsPageDataType,
} from "../../../Api/StandaloneSendsEndpoints";
import {useNavigate} from "react-router-dom";
import StackVertical from "../../../Framework/Components/Wrappers/StackVertical";
import {FlexGap} from "../../../Framework/Data/Enums/LayoutEnums";
import {ModalSize} from "../../../Framework/Data/Enums/Generic";

interface SendsPageCreatedActions extends ModalType {
    pageData: SendsPageDataType
}

const SendsPageCreatedActionsModal = (props: SendsPageCreatedActions) => {
    const navigate = useNavigate();

    const HandleRestart = async () => {
        if(props.actionedCallback) {
            props.actionedCallback();
        }
    }

    const HandleClose = () => {
        props.closeCallback();
        navigate('../', { replace: true });
    }

    return (
        <Modal title={`Created "${props.pageData?.title}"!`} isOpen={props.isOpen} closeCallback={() => HandleClose()}>
            <StackVertical gap={FlexGap.Small}>
                <Button title={'Create Another'} fullWidth={true} onClick={() => HandleRestart()} />
                <Button title={'Back to Profiles Overview'} fullWidth={true} onClick={() => HandleClose()} />
            </StackVertical>
        </Modal>
    )
}

export default SendsPageCreatedActionsModal
